import { Component } from 'react';
import * as React from 'react';

import CollapsibleForm from '../generic/CollapsibleForm';
import { capitalize } from '../utils/utils';
import TagsSections from './TagsSections';
import PreferencesModal from './PreferencesModals';
import { getSpicyTagsAC } from '../generic/global_state/action_creators';
import { connect } from 'react-redux';
import DietaryNeeds from '../../../../pages/food-profile/components/DietaryNeeds/DietaryNeeds';

// TODO: figure out what this.props.dietaryPreferences is doing

class FoodProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dietaryPrefsText: '',
      dietaryPreferenceaFormVisible: false,
      dietPrefs: [],
    };
    this.createDisplayedText = this.createDisplayedText.bind(this);
  }

  componentDidMount() {
    this.props.getSpicyTags();
  }

  createDisplayedText(prefs, options, stateKey) {
    let text = prefs.reduce((acc, pref, idx) => {
      let preference = capitalize(options[pref]['optionText']);
      if (idx === 0) {
        acc += preference;
      } else {
        acc += ', ' + preference;
      }
      return acc;
    }, '');
    this.setState({ [stateKey]: text });
  }

  toggleForm(stateKey) {
    this.setState({
      [stateKey]: !this.state[stateKey],
    });
  }

  closeForm(stateKey) {
    this.setState({
      [stateKey]: false,
    });
  }

  setDietPrefs(dietPrefs) {
    this.setState({ dietPrefs: dietPrefs });
  }

  render() {
    return (
      <React.Fragment>
        <div className="hr-mb-32">
          <CollapsibleForm
            title="Dietary Needs"
            text={this.state.dietaryPrefsText || 'Set your preferences.'}
            iconDesktop={`/public/img/preferences/dietary_icon.svg`}
            contentVisible={this.state.dietaryPreferenceaFormVisible}
            toggleForm={() => this.toggleForm('dietaryPreferenceaFormVisible')}
            dataCy={'dietary-needs'}
          >
            <DietaryNeeds
              testid="food-profile-dietary-needs-exp-99"
              onSubtextChange={this.createDisplayedText}
            />
          </CollapsibleForm>
        </div>
        <div className="hr-mb-32">
          <TagsSections dietaryPreferences={this.state.dietPrefs} />
        </div>
        <PreferencesModal />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getSpicyTags: () => dispatch(getSpicyTagsAC()),
  };
};

export default connect(null, mapDispatchToProps)(FoodProfile);
